<template>
  <section class="first-section">
    <div class="container">
      <span class="titleHeader d-block pt-4">Segmentações</span>
      <router-view />
    </div>
  </section>
</template>

<script>
import { getConfigurations } from '@/services/configurations'
import { mapMutations } from 'vuex'

export default {
  name: 'App',

  mounted () {
    this.fetchConfigurations()
    window.addEventListener('click', () => {
      parent.postMessage(document.body.offsetHeight, '*')
    })
  },

  methods: {
    ...mapMutations(['setConfigurations']),
    async fetchConfigurations () {
      const configurations = await getConfigurations()
      this.setConfigurations(configurations)
    }
  }
}
</script>
<style lang="scss">
body {
  background-color: #f5f5f5;
}
.first-section {
  min-height: 100vh;
  .titleHeader{
    font-size: 32px;
    color: #6D6D77;
    margin-bottom: 16px;
  }
}

@import './assets/scss/styles.scss';
</style>
